module.exports = __webpack_public_path__ + "static/media/icon-user.84b6bb52.svg";